import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  template: `
    <div class="main-content">
      <router-outlet></router-outlet>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'main' },
  standalone: true,
  imports: [RouterModule]
})
export class PoolsComponent {}
